<ng-container *ngIf="assignment != null">
  <!-- PREFIX -->
  <div slot="prefix" class="time-box">
    <sl-checkbox *ngIf="selectable" [(ngModel)]="selected" [disabled]="assignment.action !== 'None'" (click)="$event.stopPropagation()"></sl-checkbox>
    <ng-container *ngIf="!selectable" [ngSwitch]="layout">

      <ng-container *ngSwitchCase="'LongDue'">
        <sl-label size="x-small" color="dark">inden</sl-label>
        <sl-label size="x-small" color="medium">{{assignment.plan.completionDueTime | date:'d/M'}}</sl-label>
      </ng-container>

      <ng-container *ngSwitchCase="'Skipped'"></ng-container>

      <ng-container *ngSwitchDefault>
        <sl-label size="x-small" color="dark" class="time-box__start-time" [ngClass]="{'time-box__start-time--specific':assignment.plan.specificStartTime}">{{startTime | date:'shortTime'}}</sl-label>
        <sl-label size="x-small" color="medium" class="time-box__end-time">{{endTime | date:'shortTime'}}</sl-label>
      </ng-container>
    </ng-container>
  </div>

  <!-- CENTER -->
  <sl-label>{{assignment.contactName}}</sl-label>
  <sl-label size="small" color="dark">{{(hasDeliveryAddress ? $any(assignment).deliveryAddress : assignment.address) | address}}</sl-label>
  <sl-label size="x-small" color="light">
    <sl-tooltip content="Service window" i18n-content *ngIf="hasServiceWindow()">
      <span class="mr-3">
        <sl-icon name="clock-history"></sl-icon><span class="ml-2">{{assignment.plan.serviceWindow.startTime | date: 'shortTime'}} - {{assignment.plan.serviceWindow.endTime | date: 'shortTime'}}</span>
      </span>
    </sl-tooltip>
    
    <sl-icon *ngIf="assignment.flagged" name="flag-fill" class="mr-3"></sl-icon>
    
    <sl-tooltip *ngIf="assignment.plan.affixment.state === 'Locked'" content="Assignment is locked" i18n-content>
      <sl-icon name="lock-fill" class="mr-3"></sl-icon>
    </sl-tooltip>

    <sl-tooltip *ngIf="assignment.notifiedOfImpendingWork" content="Customer has been notified" i18n-content>
      <sl-icon name="chat-text-fill" class="mr-3"></sl-icon>
    </sl-tooltip>

    <sl-tooltip *ngIf="hasOrderStatus()" [content]="statusText">
      <sl-icon class="mr-3" name="file-text-fill"></sl-icon>
    </sl-tooltip>
  </sl-label>

  <!-- SUFFIX -->
  <sl-icon name="dash-circle-dotted" slot="suffix" *ngIf="assignment.action === 'Skipped'"></sl-icon>
  <sl-icon name="stopwatch" slot="suffix" *ngIf="assignment.action === 'InProgress'"></sl-icon>
  <sl-icon name="check-circle" slot="suffix" color="success" *ngIf="assignment.action === 'Completed'">
  </sl-icon>
  
</ng-container>